import { SidePanelContainer } from 'components/staticForm/sidePanelLayout/SidePanelContainer';
import { FC } from 'react';

import { AddonMainForm } from './AddonMainForm';
import { SidePanel } from './components/SidePanel/SidePanel';

type AddonFormProps = Readonly<{
  tabId: string;
}>;

export const AddonForm: FC<AddonFormProps> = ({ tabId }) => {
  return (
    <SidePanelContainer sidePanel={<SidePanel tabId={tabId} />} topBar={null}>
      <AddonMainForm tabId={tabId} />
    </SidePanelContainer>
  );
};

AddonForm.displayName = 'AddonForm';
